module.exports = __webpack_public_path__ + "img/fear-and-greed-light.8c97cc4.png";